import { supabase } from '../lib/supabase';

// Single project constant - Residencial 3 Volcanes
const RESIDENCIAL_3_VOLCANES = 'Residencial 3 Volcanes';

export const projectService = {
  // Get the single project (Residencial 3 Volcanes)
  async getProjects() {
    try {
      const { data, error } = await supabase
        ?.from('projects')
        ?.select('*')
        ?.eq('name', RESIDENCIAL_3_VOLCANES)
        ?.single();

      if (error) throw error;

      // Return as array for compatibility
      return data ? [{
        id: data?.id,
        name: data?.name,
        description: data?.description,
        location: data?.location,
        status: data?.status,
        settings: data?.settings,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      }] : [];
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  // Get single project (always returns Residencial 3 Volcanes)
  async getProject(projectId) {
    try {
      const { data, error } = await supabase
        ?.from('projects')
        ?.select('*')
        ?.eq('name', RESIDENCIAL_3_VOLCANES)
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        name: data?.name,
        description: data?.description,
        location: data?.location,
        status: data?.status,
        settings: data?.settings,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  // Get the default project ID
  async getDefaultProjectId() {
    try {
      const { data, error } = await supabase
        ?.from('projects')
        ?.select('id')
        ?.eq('name', RESIDENCIAL_3_VOLCANES)
        ?.single();

      if (error) throw error;
      return data?.id;
    } catch (error) {
      console.error('Error fetching default project ID:', error);
      throw error;
    }
  },

  // Update project (only Residencial 3 Volcanes can be updated)
  async updateProject(projectId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('projects')
        ?.update({
          description: updates?.description,
          location: updates?.location,
          status: updates?.status,
          settings: updates?.settings
        })
        ?.eq('name', RESIDENCIAL_3_VOLCANES)
        ?.select()
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        name: data?.name,
        description: data?.description,
        location: data?.location,
        status: data?.status,
        settings: data?.settings,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  }
};

export default projectService;